var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { PriceListStatus } from '../enums/price-list-status.enum.js';
export class PriceListResponseDto {
    id;
    name;
    payerDomainId;
    payerDomainCode;
    payerDomainName;
    validFrom;
    validTo;
    status;
    versionNumber;
    rootLineageId;
    supersedesId;
    isGlobal;
    itemCount;
    currency;
    pricingSourceName;
    hasReferences;
    updatedAt;
    lockedByUserId;
    lockedAt;
    lockedByUserName;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListResponseDto.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListResponseDto.prototype, "payerDomainId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListResponseDto.prototype, "payerDomainCode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListResponseDto.prototype, "payerDomainName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListResponseDto.prototype, "validFrom", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PriceListResponseDto.prototype, "validTo", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListResponseDto.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PriceListResponseDto.prototype, "versionNumber", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListResponseDto.prototype, "rootLineageId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PriceListResponseDto.prototype, "supersedesId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], PriceListResponseDto.prototype, "isGlobal", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PriceListResponseDto.prototype, "itemCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListResponseDto.prototype, "currency", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PriceListResponseDto.prototype, "pricingSourceName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], PriceListResponseDto.prototype, "hasReferences", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PriceListResponseDto.prototype, "lockedByUserId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PriceListResponseDto.prototype, "lockedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PriceListResponseDto.prototype, "lockedByUserName", void 0);
//# sourceMappingURL=price-list.response.dto.js.map